import React from 'react';
import {useLocation} from 'react-router-dom';

export type LocationProps = {
    location: ReturnType<typeof useLocation>;
    query: URLSearchParams;
};

export default function withLocation<P extends object>(
    Wrapped: React.ComponentType<P & LocationProps>
) {
    return function WithLocation(props: P) {
        const location = useLocation();
        const query = new URLSearchParams(location.search);
        return <Wrapped {...props} location={location} query={query}/>;
    };
}